export enum StreamEmbedType {
  YOUTUBE = "YOUTUBE",
  TWITCH = "TWITCH",
}

export interface StreamEmbedProps {
  type: StreamEmbedType | null;
  videoId: string;
}